import { Typography } from '@navi/web-ui/lib/primitives';
import KeyValue from '../KeyValue';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import { DateFormat } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { ActivityLogsType, IActivityLogs } from '../../types';

const CurrentRca = () => {
  const rcaDetails =
    useSelector((state: RootState) => state?.anomalyTracker?.acitvityLogs?.data) || [];
  const { details } =
    rcaDetails?.find((rca: IActivityLogs) => rca?.type === ActivityLogsType.RCA) || {};

  if (!details) return null;

  return (
    <div className="p-6 pb-[18px] border-0 border-b border-solid border-[var(--navi-color-gray-border)]">
      <Typography color="var(--navi-color-gray-c1)" variant={'h4'} className="pb-3">
        Current RCA
      </Typography>
      <KeyValue title="Name" description={details?.name} containerClass="mb-[6px]" />
      <KeyValue
        title="Date"
        description={
          details?.at ? dayjs(details?.at)?.format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME) : null
        }
        containerClass="mb-[6px]"
      />
      <KeyValue title="Type" description={details?.reason} containerClass="mb-[6px]" />
      <KeyValue
        title="Comments"
        description={details?.comment ? details?.comment : null}
        containerClass="mb-[6px]"
      />
    </div>
  );
};

export default CurrentRca;
